import { FunctionComponent, useEffect, useState } from "react"
import { Button, Col, Form, Modal } from "react-bootstrap"
import { Role } from "../data/models.interface"
import ItemSelect from "./ItemSelect"

interface IEntityRoleIdModal {
	onHide: () => void
	roleIds: string[]
	setRoleIds: (p: string[]) => any
	index: number | null
	roles: Role[]
}
const EntityRoleIdModal: FunctionComponent<IEntityRoleIdModal> = ({ onHide, roleIds, setRoleIds, index, roles }) => {
	const [role, setRole] = useState<Role>()
	const [touched, setTouched] = useState<EntityRoleIdTouched>({})
	// changing the index is what causes the Modal to show, so reload the fields at the same time
	useEffect(() => {
		if (index != null) {
			setRole(roles.find((d) => d.id === roleIds?.[index]))
			setTouched({})
		}
	}, [roleIds, index, roles])
	//
	const validationErrors = validate(role)
	//
	const save = () => {
		if (index != null) {
			// the modal shouldn't be open if index is undefined
			// show errors on all fields
			setTouched({ role: true })
			// don't save if there are errors
			if (Object.values(validationErrors).some((e) => !!e)) return
			//
			if (roleIds == null) {
				roleIds = [] // in case this is the first row
			} else {
				roleIds = [...roleIds] // make sure useState registers it as a new object
			}
			// add a new row if this is an add
			if (roleIds.length <= index) roleIds.push("")
			// then we can edit the new or existing row the same way
			roleIds[index] = role?.id!
			setRoleIds(roleIds) // update state
			onHide() // close the window
		}
	}
	const remove = () => {
		// the modal shouldn't be open if index is undefined
		// the remove button shouldn't be visible if roleIds is undefined
		if (roleIds && index != null) {
			roleIds = [...roleIds]
			roleIds.splice(index, 1)
			setRoleIds(roleIds) // update state
			onHide() // close the window
		}
	}
	//
	return (
		<Modal show={index != null} onHide={onHide}>
			<Modal.Header closeButton={true}>
				<Modal.Title>Edit Pass</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className="mb-3" controlId="door">
					<Form.Label>Pass</Form.Label>
					<ItemSelect
						placeholder="--Select a Role--"
						required
						valueId={role?.id}
						onChange={setRole}
						onBlur={() => setTouched({ ...touched, role: true })}
						items={roles}
						convert={(d) => ({ id: d.id, name: d.name })}
						isInvalid={touched.role && validationErrors.role != null}
					/>
					<Form.Control.Feedback type="invalid">{validationErrors.role}</Form.Control.Feedback>
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" disabled={false} onClick={onHide}>
					Cancel
				</Button>
				<Button variant="danger" hidden={index != null && index >= (roleIds?.length || 0)} onClick={remove}>
					Remove
				</Button>
				<Col></Col>
				<Button variant="primary" disabled={false} onClick={save}>
					OK
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
export default EntityRoleIdModal

const validate = (role?: Role) => {
	const validationErrors: EntityRoleIdErrors = {}
	if (!role) validationErrors.role = "Role is required."
	return validationErrors
}

interface EntityRoleIdTouched {
	role?: boolean
}
interface EntityRoleIdErrors {
	role?: string
}
